import { WorkspaceUploadRequest } from "@/types/workspace";
import axiosInstance from "./api";

export const uploadPbixReport = async (request: WorkspaceUploadRequest) => {
    const response = await axiosInstance.post('/Workspace/Upload', 
     request,
      {
      headers: {
        'Content-Type': 'multipart/form-data' 
      }
    });
    return response.data;
  };